var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "formValidation",
    attrs: { slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ pristine, invalid }) {
          return [
            _c("OpenRegistrationSettingsForm", {
              model: {
                value: _vm.registrationForm,
                callback: function($$v) {
                  _vm.registrationForm = $$v
                },
                expression: "registrationForm"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-sm-8 col-md-8 col-md-offset-3 col-sm-offset-3"
                },
                [
                  _c("PrimaryButton", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "SAVE",
                        expression: "'SAVE'"
                      }
                    ],
                    attrs: {
                      size: "sm",
                      disabled: pristine || invalid,
                      "show-loader-on-form":
                        _vm.saveSettingsStatus.status == "pending"
                    },
                    on: { click: _vm.submit }
                  })
                ],
                1
              )
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }